export const CompanyPrivilegeFlag = {
    ProcessExternal: 'processExternal',
    CreditEnabled: 'creditEnabled',
};
